






































import { Component, Vue, Ref, Emit } from 'vue-property-decorator'
import { State } from 'vuex-class'
import UploadButton from '@/features/upload/components/UploadButton.vue'
import ChooseSheetDialog from '@/features/upload/components/ChooseSheetDialog.vue'
import AdvancedParsingOptionsDialog from '@/features/upload/components/AdvancedParsingOptionsDialog.vue'
import { uploadLocalisationKeys } from '@/features/upload/upload.localisation'
import { IStore } from '@/system/store'
import { IParsingOptions } from '../store'

@Component({
  components: {
    UploadButton,
    ChooseSheetDialog,
    AdvancedParsingOptionsDialog
  }
})
export default class Upload extends Vue {
  private translations = uploadLocalisationKeys
  private selectedSheetName: string = ''
  private dateFormat: string = ''

  @State(({ upload }: IStore) => upload.parsingOptions)
  parsingOptions!: IParsingOptions

  @Ref()
  readonly modal!: ChooseSheetDialog
  @Ref()
  readonly parsingOptionsDialog!: AdvancedParsingOptionsDialog
  @Ref()
  readonly uploadButton!: any

  public openParsingOptions (): void {
    this.parsingOptionsDialog.openDialog()
  }

  public showDialogChooseSheet (sheetNames: string[]): void {
    if (sheetNames.length > 1) return this.modal.openDialog(sheetNames)
    this.chooseSheetName(sheetNames[0])
  }

  public chooseSheetName (selectedSheetName: string): void {
    this.selectedSheetName = selectedSheetName
    this.uploadButton.upload()
  }
}
